import {generateDefaultModel} from '@github-ui/copilot-chat-state/models'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useSearchParams} from '@github-ui/use-navigate'
import {useEffect, useEffectEvent, useRef} from 'react'

import LoggedOutView from '../components/LoggedOutView/LoggedOutView'
import {CopilotContext} from './../contexts/CopilotContext'
import {useInitialCopilotContext} from './../hooks/useInitialCopilotContext'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CopilotImmersiveLoggedOutProps {}

const defaultProps: Partial<CopilotImmersiveLoggedOutProps> = {}

const CopilotImmersiveLoggedOut = (props: CopilotImmersiveLoggedOutProps) => {
  const initializedProps: CopilotImmersiveLoggedOutProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  const [searchParams, setSearchParams] = useSearchParams()
  const defaultModel = generateDefaultModel()
  const autoPopulated = useRef(false)

  const {copilotContextValue} = useInitialCopilotContext({defaultModel})

  // Runs once (guarded by the ref): seeds the prompt from the query string and
  // strips legacy deep-link params. An effect event reads the latest
  // searchParams/setSearchParams/context without making them reactive triggers.
  const populateFromDeepLink = useEffectEvent(() => {
    if (autoPopulated.current) return
    autoPopulated.current = true

    const queryPrompt = searchParams.get('prompt')
    if (queryPrompt) copilotContextValue.setPrompt(queryPrompt)

    // Picker is non-selectable for logged-out users; drop legacy deep-link params.
    const newSearchParams = new URLSearchParams(searchParams)
    newSearchParams.delete('prompt')
    newSearchParams.delete('model')
    setSearchParams(newSearchParams, {replace: true})
  })

  useEffect(() => {
    populateFromDeepLink()
  }, [])

  return (
    <CopilotContext value={copilotContextValue}>
      <LoggedOutView
        initialModelId={defaultModel.id}
        onIdeListItemClick={(_, ideName) => {
          sendEvent('click', {
            category: 'copilot_loggedOut',
            action: 'ide_option_click',
            label: 'copilot_loggedOut',
            ideName,
          })
        }}
      />
    </CopilotContext>
  )
}

export default CopilotImmersiveLoggedOut
